import React from 'react';
import {
  useDropzone,
  useFileInput,
} from '@uppy/react';

const DashboardAdminAssetsDropzone: React.FC = () => {
  const { getRootProps, getInputProps } = useDropzone();
  const { getButtonProps } = useFileInput();

  return (
    <div className="dashboard-assets-dropzone">
      <input {...getInputProps()} className="wa-visually-hidden" />
      <div {...getRootProps()} className="dropzone-area">
        <i className="fa-light fa-arrow-up-from-bracket fa-3x" />
        <p><strong>Drop files here or browse</strong></p>
        <wa-button {...getButtonProps()}>
          Choose files
        </wa-button>
      </div>
    </div>
  );
}

export default DashboardAdminAssetsDropzone;
